<template>
  <div>
    <review-criteria-settings-panel
      :review="review"
      @save-criteria="onSaveCriteria"
      @delete-criteria="onDeleteCriteria"
    />
    <review-criteria-in-use-error
      v-model="showInUseError"
      :review-criteria="showInUseErrorFor"
    />
  </div>
</template>

<script>
import ReviewCriteriaSettingsPanel from '@/components/ReviewSettingsPage/ReviewCriteriaSettingsPanel';
import ReviewCriteriaInUseError from '@/components/ReviewSettingsPage/ReviewCriteriaInUseError';
import { Review } from '@/models';
import { mapActions } from 'vuex';

export default {
  name: 'ReviewCriteriaSettingsController',
  components: {
    ReviewCriteriaSettingsPanel,
    ReviewCriteriaInUseError,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  data: () => ({
    showInUseError: false,
    showInUseErrorFor: null,
  }),
  methods: {
    ...mapActions({
      saveReviewCriteria: 'reviewCriteria/saveReviewCriteria',
      deleteReviewCriteria: 'reviewCriteria/deleteReviewCriteria',
    }),
    onSaveCriteria(criteria) {
      this.saveReviewCriteria(criteria);
    },
    async onDeleteCriteria(criteria) {
      try {
        await this.deleteReviewCriteria(criteria);
      } catch (error) {
        if (error.graphQLErrors) {
          const deleteNotAllowed = error.graphQLErrors.some(
            (error) =>
              error.extensions.type ===
              'ReviewCriteriaDeleteNotAllowedException'
          );
          if (deleteNotAllowed) {
            this.showInUseError = true;
            this.showInUseErrorFor = criteria;
          }
        }
      }
    },
  },
};
</script>
